import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ExaFileComponent } from './exa-file/exa-file.component';
import { DateFormatPipe } from './_pipe/date-format.pipe';
import { DisableControlDirective } from './_directives/disable-control.directive';
import { NumbersFormatterDirective } from './_directives/numbers-formatter.directive';
import { PasswordValidators } from './_validators/password.validators';
import { NameValidators } from './_validators/name.validators';
import { SelectboxValidators } from './_validators/selectbox.validators';
import { ExaFileValidators } from './_validators/exafile-validators';
import { NumberRangeValidators } from './_validators/number-range-validators';
import { AlertService } from './_services/alert.service';
import { AlertComponent } from './alert/alert.component';
import { CacheService } from './_services/cache.service';
import { CKEditorModule } from 'ng2-ckeditor';
import { UrlValidators } from './_validators/url.validators';
import { ExaFooter, ExaTemplate, ExaHeader } from './common/shared';
import { ExaComboboxComponent } from './exa-combobox/exa-combobox.component';
import { ExaInsertViewComponent } from './exa-insert-view/exa-insert-view.component';

const EXA_CMPS = [
    AlertComponent,

    ExaFileComponent,
    ExaInsertViewComponent,

    ExaComboboxComponent,
    ExaHeader,
    ExaFooter,
    ExaTemplate,

    DateFormatPipe,

    DisableControlDirective,
    NumbersFormatterDirective,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        CKEditorModule,
    ],
    declarations: EXA_CMPS,
    exports: EXA_CMPS,
    providers: [
        PasswordValidators,
        NameValidators,
        SelectboxValidators,
        ExaFileValidators,
        NumberRangeValidators,
        UrlValidators,

        AlertService,
        CacheService,
    ],
})
export class ExaModule {
    static CONFIRMAPOPUP_OPTIONS = {
        confirmText: 'Ok',
        cancelText: 'annulla',
        cancelButtonType: 'exa-confirmCancelButton',
        confirmButtonType: 'danger',
        popoverClass: 'exa-confirm-popup',
        reverseButtonOrder: true,
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/exa.module.ts